var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeter3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 81,
    viewBox: "0 0 153 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.647 80.5812C106.027 80.5633 104.472 79.9426 103.286 78.8404C102.1 77.7381 101.368 76.2336 101.234 74.6208C100.693 68.4411 97.854 62.6881 93.2763 58.497C88.6987 54.3059 82.715 51.9809 76.5058 51.9809C70.2966 51.9809 64.3129 54.3059 59.7353 58.497C55.1576 62.6881 52.3185 68.4411 51.7781 74.6208C51.6433 76.2336 50.9114 77.7381 49.7253 78.8404C48.5393 79.9426 46.9844 80.5633 45.3646 80.5812H9.10509C7.9169 80.5811 6.74129 80.3382 5.65051 79.8675C4.55973 79.3969 3.57681 78.7083 2.76221 77.8441C1.97272 77.0112 1.36541 76.0232 0.978888 74.9431C0.592364 73.8629 0.435094 72.7142 0.517102 71.57C1.78825 52.3021 10.3461 34.2381 24.4555 21.0406C38.5648 7.84317 57.1697 0.5 76.4979 0.5C95.8262 0.5 114.431 7.84317 128.54 21.0406C142.65 34.2381 151.208 52.3021 152.479 71.57C152.561 72.7142 152.404 73.8629 152.017 74.9431C151.631 76.0232 151.023 77.0112 150.234 77.8441C149.419 78.7083 148.436 79.3969 147.345 79.8675C146.255 80.3382 145.079 80.5811 143.891 80.5812H107.647Z",
    fill: "url(#paint0_linear_9_6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.647 80.0949C106.153 80.079 104.718 79.508 103.623 78.4932C102.527 77.4783 101.849 76.0923 101.72 74.6051C101.196 68.2821 98.3118 62.3871 93.6396 58.09C88.9673 53.7928 82.8487 51.4075 76.498 51.4075C70.1474 51.4075 64.0288 53.7928 59.3566 58.09C54.6843 62.3871 51.8 68.2821 51.2758 74.6051C51.1471 76.0923 50.4689 77.4783 49.3733 78.4932C48.2776 79.508 46.843 80.079 45.349 80.0949H9.10513C7.9835 80.095 6.87365 79.8662 5.84369 79.4225C4.81373 78.9789 3.88537 78.3296 3.11552 77.5147C2.37343 76.7282 1.80211 75.7969 1.43737 74.7793C1.07263 73.7617 0.922337 72.6798 0.995996 71.6014C2.29143 52.4778 10.8092 34.5596 24.8261 21.4718C38.8429 8.38399 57.3124 1.10367 76.498 1.10367C95.6837 1.10367 114.153 8.38399 128.17 21.4718C142.187 34.5596 150.705 52.4778 152 71.6014C152.073 72.6803 151.921 73.7626 151.555 74.7802C151.189 75.7978 150.616 76.7288 149.873 77.5147C149.105 78.3301 148.178 78.9798 147.149 79.4236C146.12 79.8673 145.011 80.0958 143.891 80.0949H107.647Z",
    fill: "url(#paint1_linear_9_6)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_6",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 145,
    height: 73
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.601 71.8288C147.364 53.566 139.23 36.4542 125.844 23.9554C112.458 11.4565 94.82 4.50385 76.4979 4.50385C58.1758 4.50385 40.5377 11.4565 27.1518 23.9554C13.766 36.4542 5.63187 53.566 4.39502 71.8288C4.36378 72.4624 4.46303 73.0956 4.68662 73.6892C4.91022 74.2829 5.25338 74.8244 5.69491 75.2802C6.13643 75.736 6.66689 76.0964 7.25347 76.3391C7.84004 76.5818 8.47026 76.7017 9.10507 76.6912H45.3488C45.9877 76.6837 46.6008 76.4384 47.0682 76.0033C47.5356 75.5682 47.8239 74.9746 47.8766 74.3385C48.4829 67.1717 51.7609 60.4938 57.0615 55.6269C62.3621 50.7601 69.2988 48.0592 76.4979 48.0592C83.6971 48.0592 90.6338 50.7601 95.9344 55.6269C101.235 60.4938 104.513 67.1717 105.119 74.3385C105.172 74.9746 105.46 75.5682 105.928 76.0033C106.395 76.4384 107.008 76.6837 107.647 76.6912H143.891C144.526 76.7017 145.156 76.5818 145.742 76.3391C146.329 76.0964 146.859 75.736 147.301 75.2802C147.743 74.8244 148.086 74.2829 148.309 73.6892C148.533 73.0956 148.632 72.4624 148.601 71.8288Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M149.001 76.5579C149.001 90.884 144.749 104.888 136.782 116.8C128.815 128.712 117.492 137.996 104.244 143.478C90.9955 148.961 76.4175 150.395 62.3533 147.6C48.289 144.805 35.3702 137.907 25.2304 127.777C15.0906 117.646 8.18534 104.74 5.38778 90.6891C2.59023 76.6383 4.02607 62.0742 9.51367 48.8386C15.0013 35.603 24.2942 24.2903 36.2173 16.3311C48.1404 8.37197 62.1581 4.12378 76.4979 4.12378C95.7264 4.12586 114.167 11.758 127.763 25.3415C141.36 38.9251 148.999 57.3478 149.001 76.5579Z",
    fill: "url(#paint2_radial_9_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_6",
    x1: 76.498,
    y1: 80.5812,
    x2: 76.498,
    y2: 0.610319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_6",
    x1: 76.4981,
    y1: 80.0949,
    x2: 76.4981,
    y2: 1.09658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.498 76.5579) scale(72.5033 72.4341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EBECF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#DADDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#C4C9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A8B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#8993BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6572A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter3);
export default __webpack_public_path__ + "static/media/meter3.8b88e68626b7b122b3dde5e1355f39cc.svg";
export { ForwardRef as ReactComponent };